import styled from "styled-components"

import Button from "components/presenters/common/form/Button"

export default function SaveBtn({ onClick }) {
  return (
    <ButtonStyle onClick={onClick} fullWidth>
      저장
    </ButtonStyle>
  )
}

const ButtonStyle = styled(Button)`
  padding: calc(100vw * (23 / 375)) 0;
  font-size: calc(100vw * (18 / 375));
  font-weight: 700;
  line-height: calc(100vw * (26 / 375));
`
